module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<a class="top_link" href="' +
__e( href ) +
'">\n    <div class="pull-left left_icon hide">' +
((__t = ( leftIcon )) == null ? '' : __t) +
'</div>\n    <div class="pull-right progression hide"></div>\n    <div class="pull-right right_icon hide">' +
((__t = ( rightIcon )) == null ? '' : __t) +
'</div>\n    ' +
__e( label) +
'\n\n    <div class="help-block description hide"></div>\n</a>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./js/ui/navPillsStacked/listItem.ejs
// module id = 359
// module chunks = 3